import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  hours?: number;
  minutes?: number;
  seconds?: number;
}
export function CountdownTimer({
  hours = 2,
  minutes = 0,
  seconds = 0
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(hours * 3600 + minutes * 60 + seconds);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 my-4" data-id="element-36">
      <span className="text-xs text-gray-500 uppercase tracking-wide font-medium" data-id="element-37">
        La oferta termina en:
      </span>
      <div className="flex gap-1" data-id="element-38">
        {[{
        value: pad(h),
        label: 'h'
      }, {
        value: pad(m),
        label: 'm'
      }, {
        value: pad(s),
        label: 's'
      }].map((unit, idx) => <div key={idx} className="flex items-center gap-0.5" data-id="element-39">
            <span className="bg-navy text-white font-heading font-bold text-lg md:text-xl px-2 py-1 rounded-md min-w-[36px] text-center" data-id="element-40">
              {unit.value}
            </span>
            <span className="text-navy font-bold text-xs" data-id="element-41">{unit.label}</span>
          </div>)}
      </div>
    </div>;
}